module.exports = __webpack_public_path__ + "static/img/2_01.3770d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/junActivity/2_01.jpg
// module id = Z4NX
// module chunks = 0